import 'babel-polyfill'
import Promise from 'es6-promise'
Promise.polyfill()
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import store from './vuex'
import Vuex from 'vuex'
import router from './router'
import './router/engine'
import './utils/directive.js'
import echarts from 'echarts'
import "./assets/css/font/font.css"
import 'font-awesome/css/font-awesome.min.css'
import './assets/css/index.scss'
import api from './api'
import 'default-passive-events'
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.prototype.$echarts = echarts
Vue.prototype.$api = api

import moment from "moment"
Vue.prototype.$moment = moment;

// 引用公共组件库vue-common中的组件和文件
import { svgIcon, utils } from 'vue-common-laboratory'
import 'vue-common-laboratory/src/assets/css/index.scss'
Vue.use(svgIcon)
Vue.mixin(utils.mixin)

import md5 from "js-md5"
Vue.prototype.$md5 = md5
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
// 引用公共配置文件
import './common.js'


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 定义全局过滤器
Vue.filter('formatDate', function(value) {
  if (!value) return '';
  // 创建一个Date对象，并传入时间戳
  const date = new Date(value);
  // 使用toISOString将日期格式化为YYYY-MM-DD
  const isoString = date.toISOString();
  // 将ISO字符串分割并取前面的日期部分
  return isoString.slice(0, 10);
});


// WEBPACK FOOTER //
// ./src/main.js